import { WAREHOUSES_GRID_ROUTE, WAREHOUSES_DT_FORM_ROUTE } from '../../../modules/warehouses/consts';

export const ASSIGN_VENDORS_TO_WAREHOUSE_PATH = '/settings/warehouses/warehouse-assign-vendors/:id';
export const ASSIGN_VENDORS_TO_WAREHOUSE_ROUTE = '/settings/warehouses/warehouse-assign-vendors';

export default {
    name: 'assignVendorsToWarehousePage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'assignVendorsToWarehouseRoute';
        app.routes.addItem(routeName, {
            path: ASSIGN_VENDORS_TO_WAREHOUSE_PATH,
            breadcrumbConfig: { title: 'Assign Vendors', isReplaceble: true },
            permission: ['warehouses.index'],
            props: () => ({
                indexPageRoute: WAREHOUSES_GRID_ROUTE,
                detailsPageRoute: WAREHOUSES_DT_FORM_ROUTE,
            }),
            loader: () => import('./packages/AssignVendors/core'),
        });
    },
};
